/* eslint-disable */
/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
import DatePicker from 'tui-date-picker';
import AutoComplete from './autocomplete';
import CustomSelect from './customselect';
import { remove } from 'lodash';

const inputs = () => {
  DatePicker.localeTexts.pl = {
    titles: {
      // days
      DD: [
        'Niedziela',
        'Poniedziałek',
        'Wtorek',
        'Środa',
        'Czwartek',
        'Piątek',
        'Sobota',
      ],
      // daysShort
      D: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
      // months
      MMMM: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      // monthsShort
      MMM: [
        'Sty',
        'Lut',
        'Mar',
        'Kwi',
        'Maj',
        'Cze',
        'Lip',
        'Sie',
        'Wrz',
        'Paź',
        'Lis',
        'Gru',
      ],
    },
    titleFormat: 'MMMM yyyy',
    todayFormat: 'DD, dd.MM.yyyy',
    date: 'Data',
    time: 'Czas',
  };

  // if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
  const calendars = document.querySelectorAll('.c-input--date');
  let start = document.querySelector('#ks_start_date');
  let end = document.querySelector('#ks_end_date');
  if (start && end) {
    start = start.value;
    end = end.value;
    calendars.forEach(element => {
      if (
        element.getAttribute('id') !== 'ks_start_date' &&
        element.getAttribute('id') !== 'ks_end_date'
      ) {
        element.setAttribute('type', 'text');
        const container = element.parentElement.querySelector('.js-calendar');
        const datepicker = new DatePicker(container, {
          language: document.querySelector('html').getAttribute('lang'),
          input: {
            element,
          },
        });
      }
    });
    let range = [[new Date(), new Date(2999, 11, 31)]];
    const firstEvent = document.querySelector(
      '.c-event-list-container .fc-header-toolbar',
    );
    const startDate = start
      ? new Date(
        start.substring(6, 10),
        start.substring(3, 5) - 1,
        start.substring(0, 2),
      )
      : new Date();
    if (firstEvent && firstEvent.getAttribute('data-mode') === 'past') {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      range = [[new Date(2015, 0, 1), d]];
    }
    const addOrUpdateUrlParam = (href, name, value) => {
      let regex = new RegExp(`[&\\?]${name}=`);
      if (regex.test(href)) {
        regex = new RegExp(`([&\\?])${name}=([\\d\\.])+`);
        return href.replace(regex, `$1${name}=${value}`);
      }

      if (href.indexOf('?') > -1) return `${href}&${name}=${value}`;
      return `${href}?${name}=${value}`;
    };
    const rangepicker = DatePicker.createRangePicker({
      startpicker: {
        input: '#ks_start_date',
        container: '#ks_start_date-container',
        date: startDate,
      },
      endpicker: {
        input: '#ks_end_date',
        container: '#ks_end_date-container',
        date: new Date(
          end.substring(6, 10),
          end.substring(3, 5) - 1,
          end.substring(0, 2),
        ),
      },
      language: document.querySelector('html').getAttribute('lang'),
      type: 'date',
      // format: 'yyyy-MM-dd',
      format: 'dd.MM.yyyy',
      selectableRanges: range,
    });
    const updateDate = () => {
      const chosenStartDate = document.querySelector('#ks_start_date').value;
      const chosenEndDate = document.querySelector('#ks_end_date').value;
      let url = window.location.href;
      if (chosenStartDate) {
        url = addOrUpdateUrlParam(url, 'ks_start', chosenStartDate);
      }
      if (chosenEndDate) {
        url = addOrUpdateUrlParam(url, 'ks_end', chosenEndDate);
      }
      window.location.href = url;
    };
    rangepicker.on('change:start', updateDate);
    rangepicker.on('change:end', updateDate);
  }
  // }
  document.querySelectorAll('.js-password').forEach(element => {
    element.addEventListener('click', e => {
      const input = e.target.parentElement.querySelector('input');
      input.setAttribute(
        'type',
        input.getAttribute('type') === 'text' ? 'password' : 'text',
      );
    });
  });
  document.querySelectorAll('.js-select').forEach(element => {
    const args = {
      elem: element,
    };
    const select = new CustomSelect(args);
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    ) {
      element.addEventListener('change', e => {
        e.target.parentElement.querySelector(
          '.c-select__title',
        ).innerText = e.target.parentElement.querySelector(
          `option[value="${e.target.value}"]`,
        ).innerText;
      });
    }
    element.addEventListener('change', e => {
      if (e.target.classList.contains('js-select-link')) {
        document
          .querySelector(`.js-select-target[data-mode="${e.target.value}"]`)
          .click();
      }
    });
  });
  document.querySelectorAll('.js-textarea').forEach(element => {
    const counter = element.parentElement.querySelector('.js-counter-current');
    if (counter) {
      const max = parseInt(
        counter.parentElement.querySelector('.js-counter-max').innerText,
        10,
      );
      counter.innerText = element.value.length;
      if (element.value.length > max) {
        counter.parentElement.classList.add('is-error');
      } else {
        counter.parentElement.classList.remove('is-error');
      }
    }
  });
  document.addEventListener('keyup', e => {
    if (e.target && e.target.classList.contains('js-textarea')) {
      const counter = e.target.parentElement.querySelector(
        '.js-counter-current',
      );
      if (counter) {
        const max = parseInt(
          counter.parentElement.querySelector('.js-counter-max').innerText,
          10,
        );
        counter.innerText = e.target.value.length;
        if (e.target.value.length > max) {
          counter.parentElement.classList.add('is-error');
        } else {
          counter.parentElement.classList.remove('is-error');
        }
      }
    }
  });
  // document.querySelectorAll('.js-autocomplete').forEach(element => {
  //   const autocomplete = new AutoComplete({
  //     selector: element,
  //     minChars: 1,

  //     source(term, suggest) {
  //       const termLC = term.toLowerCase();
  //       const choices = ['ActionScript', 'AppleScript', 'Asp'];
  //       const matches = [];
  //       for (let i = 0; i < choices.length; i += 1)
  //         if (~choices[i].toLowerCase().indexOf(termLC))
  //           matches.push(choices[i]);
  //       if (matches.length < 5) {
  //         suggest(matches);
  //       }
  //     },
  //   });
  // });

  function basename(path) {
    return path.split('/').reverse()[0] === ''
      ? path.split('/').reverse()[1]
      : path.split('/').reverse()[0];
  }

  document.querySelectorAll('.js-autocomplete').forEach(element => {
    const lang = document.querySelector('html').getAttribute('lang');
    const autocomplete = new AutoComplete({
      selector: element,
      minChars: 4,
      source(term, response) {
        const request = new XMLHttpRequest();
        request.open(
          'GET',
          `/${element.getAttribute('data-action')}-data?lang=${lang}`,
          true, 
        );
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            const termLC = term.toLowerCase();
            const choices = JSON.parse(request.responseText);
            const suggestions = [];
            for (let i = 0; i < choices.length; i++) {
              for (let j = 0; j < choices[i].length; j++) {
                if (j !== 1) {
                  if (
                    ~`${choices[i][0]} ${choices[i][j]}`
                      .toLowerCase()
                      .indexOf(termLC)
                  )
                    if (!suggestions.includes(choices[i]))
                      suggestions.push(choices[i]);
                }
              }
            }
            if (suggestions.length === 0) {
              if (lang === 'pl') {
                if (element.getAttribute('data-action') == 'languages') {
                  suggestions.push([
                    'Proszę spróbuj inną lub bardziej ogólną nazwę języka',
                    'info',
                  ]);
                } else {
                  suggestions.push([
                    'Proszę spróbuj inną lub bardziej ogólną nazwę lub wybierz z listy poniżej',
                    'info',
                  ]);
                }
              } else {
                if (element.getAttribute('data-action') == 'languages') {
                  suggestions.push([
                    'Please try a different or more general name of language',
                    'info',
                  ]);
                } else {
                  suggestions.push([
                    'Please try a different or more general name or choose from the list below',
                    'info',
                  ]);
                }
              }
            }
            response(suggestions);
          }
        };

        request.send(`term=${term}`);
      },
      renderItem(item, search) {
        const searchPreg = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        const re = new RegExp(`(${search.split(' ').join('|')})`, 'gi');
        let htmlItem = '';
        if (item[1] !== 'info') {
          htmlItem = `<div class="autocomplete-suggestion o-link" data-goto="${item[1]
            }" data-mode="${element.getAttribute('data-mode')}">${item[0]}</div>`;
        } else {
          htmlItem = `<div class="autocomplete-suggestion u-font-color--2">${item[0]
            }</div>`;
        }
        return htmlItem;
      },
      onSelect(e, term, item) {
        if (item.getAttribute('data-mode') === 'link') {
          window.location.href = item.getAttribute('data-goto');
        } else if (item.getAttribute('data-mode') === 'langs') {
          let currentValue = document.querySelector('.js-langs').value === "" ? [] : document.querySelector('.js-langs').value.split(',');
          if (currentValue.indexOf(item.getAttribute('data-goto')) < 0) {
            currentValue.push(item.getAttribute('data-goto'));
            document.querySelector('.js-langs').value = currentValue.join(',');
            let list = document.querySelector('.js-langs-list');
            list.innerHTML += `<li class="o-list-bare__item">${item.innerText}<span class="c-close js-item-remove" data-item="${item.getAttribute('data-goto')}">&times;</span></li>`;
            document.querySelectorAll('.js-item-remove').forEach(closebtn => {
              closebtn.addEventListener('click', e => {
                let currentValue = document.querySelector('.js-langs').value.split(',');
                remove(currentValue, function (n) {
                  return n === closebtn.getAttribute('data-item');
                });
                document.querySelector('.js-langs').value = currentValue.join(',');
                closebtn.parentElement.remove();
              });
            });
          }
        } else {
          const form = document.querySelector('.js-search-filters-form');
          const el = document.querySelector(
            `input[data-goto="${basename(item.getAttribute('data-goto'))}"]`,
          );
          el.checked = true;
          el.dispatchEvent(new Event('change'));
          if (form) {
            form.dispatchEvent(new Event('change'));
          }
        }
      },
    });
    
  });

  function readableBytes(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    // eslint-disable-next-line no-restricted-properties
    return `${(bytes / Math.pow(1024, i)).toFixed(2) * 1} ${sizes[i]}`;
  }

  document.addEventListener('click', event => {
    event.stopPropagation();
    const element = event.target;
    if (element.classList.contains('js-file-reset') || element.classList.contains('js-remove-elem')) {
      document
        .getElementById(element.getAttribute('data-input'))
        .parentElement.classList.remove('is-chosen');
      document
        .getElementById(element.getAttribute('data-input'))
        .parentElement.parentElement.classList.remove('is-chosen');
      let inputFile = element.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
        '.js-file',
      );
      if (element.classList.contains('js-remove-elem')) {
        inputFile = element.parentElement.querySelector(
          'label .js-file',
        );
      }
      const inputFileCheck = inputFile.parentElement.querySelector(
        '.js-input-remove-check',
      );
      // console.log(inputFile);
      // console.log(inputFile.getAttribute('name'));
      // console.log(
      //   document.querySelector(
      //     `.js-input-content[data-field="${inputFile.getAttribute('name')}"]`,
      //   ),
      // );
      // const inputDesc = element.parentElement.parentElement.parentElement.parentElement.querySelector(
      //   '.js-textarea',
      // );
      document
        .querySelector(
          `.js-input-content[data-field="${inputFile.getAttribute('name')}"]`,
        )
        .classList.add('u-hidden');
      inputFile.value = '';
      inputFileCheck.value = '0';
      const evt = new CustomEvent('change');
      inputFile.dispatchEvent(evt);
      inputFile.parentElement.classList.remove('is-dragover');
      setTimeout(() => {
        if (element.classList.contains('js-remove-elem')) {
          element.parentElement.querySelector('label .c-filelist').innerHTML =
            '';
          element.classList.add('u-hidden');

        } else {
          element.parentElement.parentElement.parentElement.parentElement.innerHTML =
            '';
        }
        const imagePreview = inputFile.parentElement.parentElement.querySelector(
          '.js-image-preview',
        );
        if (imagePreview) {
          if (element.classList.contains('js-remove-elem')) {
            imagePreview.parentElement.classList.add('u-hidden');
          }
          imagePreview.classList.remove('u-hidden');
        }
        const imagePreviewForm = inputFile.parentElement;
        if (imagePreviewForm) {
          imagePreviewForm.classList.remove('u-hidden');
        }
      }, 100);
    }
  });
  document.querySelectorAll('.js-file').forEach(element => {
    element.addEventListener('change', e => {
      const input = e.target;
      const types = input.getAttribute('accept').split(',');
      if (input.files.length > 0) {
        input.parentElement.querySelector(`input[name="check-${input.name}"`).value = "0"
        let removeItem = input.parentElement.parentElement.parentElement.querySelector('.js-remove-elem');
        if (removeItem) {
          removeItem.classList.add('u-hidden');
        }
        if (
          input.files[0].size > input.dataset.filesize ||
          !types.includes(input.files[0].type)
        ) {
          input.parentElement.parentElement.classList.add('has-error');
          input.value = '';
          input.parentElement.classList.remove('is-dragover');
        } else {
          input.parentElement.parentElement.classList.remove('has-error');
          input.parentElement.classList.add('is-chosen');
          input.parentElement.parentElement.classList.add('is-chosen');
          const list = input.parentElement.parentElement.querySelector(
            '.js-filelist',
          );
          list.innerHTML = '';
          for (let i = 0; i < input.files.length; i += 1) {
            const previewImage = list.parentElement.querySelector(
              '.js-image-preview',
            );
            const previewImageForm = list.parentElement.querySelector(
              '.js-remove-elem--form',
            );
            if (previewImage) {
              previewImage.parentElement.classList.add('u-hidden');
              previewImageForm.classList.add('u-hidden');
            }
            list.innerHTML += `<li class="o-list-bare__item">
            <div class="c-file">
              <img class="c-file__icon" src="/wp-content/themes/trade-gov-chisel/dist/assets/images/svg/File.svg" alt="">
              <div class="c-file__data">
                <p class="c-file__name">
                  ${input.files[i].name}
                </p>
                <div class="c-file__remove js-file-reset" data-input="${input.getAttribute(
              'id',
            )}">&times;</div>
                <p class="c-file__desc">${readableBytes(
              input.files[i].size,
            )}</p>
              </div>
            </div>`;
            if (input.name !== 'company-logo') {
              list.innerHTML += `<label class="c-label">
                  <textarea required name="${input.getAttribute(
                'name',
              )}-desc" placeholder="Opis pliku w języku angielskim *" maxlength="120" class="c-textarea c-textarea--small js-textarea"></textarea>
                  <div class="c-textarea__footer">
                      <span class="c-textarea__counter"><span class="c-textarea__counter-current js-counter-current">0</span>/<span class="js-counter-max">120</span></span>
                  </div>
              </label>`;
            }
            list.innerHTML += `</li>`;
          }
        }
      } else {
        input.parentElement.classList.remove('is-chosen');
        input.parentElement.parentElement.classList.remove('is-chosen');
      }
    });
    element.addEventListener('dragover', e => {
      e.target.parentElement.classList.add('is-dragover');
    });
    element.addEventListener('dragleave', e => {
      e.target.parentElement.classList.remove('is-dragover');
    });
  });
  document.querySelectorAll('.js-toggle-labels').forEach(element => {
    element.addEventListener('click', e => {
      e.target.classList.toggle('is-active');
      e.target.parentElement.parentElement
        .querySelectorAll(
          '.c-label:not(.c-label--toggleable):not(.c-label--group)',
        )
        .forEach(el => {
          el.classList.toggle('is-toggled');
        });
    });
  });
  document.querySelectorAll('.js-toggle-all').forEach(element => {
    element.addEventListener('change', e => {
      e.target.parentElement.parentElement.parentElement
        .querySelectorAll(' input')
        .forEach(el => {
          // eslint-disable-next-line no-param-reassign
          el.checked = e.target.checked;
        });
    });
  });

  const checkboxGroupTarget = document.querySelectorAll(
    '.js-checkbox-group-target',
  );

  function handleGroupState(group) {
    const activeCount = group.querySelectorAll(
      '.js-checkbox-group-target:checked',
    ).length;
    const groupLeader = group.querySelector('.js-checkbox-group');
    if (activeCount > 0 && activeCount < groupLeader.dataset.count) {
      groupLeader.parentElement
        .querySelector('.c-checkbox__replacement')
        .classList.add('is-halfly-completed');
    } else {
      groupLeader.parentElement
        .querySelector('.c-checkbox__replacement')
        .classList.remove('is-halfly-completed');
    }
    if (activeCount >= groupLeader.dataset.count) {
      groupLeader.checked = true;
    } else if (activeCount <= 0) {
      groupLeader.checked = false;
    }
  }

  checkboxGroupTarget.forEach(element => {
    // on page load
    let group = element.parentElement.parentElement;
    handleGroupState(group);

    element.addEventListener('change', e => {
      group = e.target.parentElement.parentElement;
      handleGroupState(group);
    });
  });

  document.querySelectorAll('.js-harmony-item').forEach(element => {
    element.addEventListener('click', e => {
      e.target.parentElement.classList.toggle('is-active');
    });
  });
};

export default inputs;
/* eslint-enable */



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/inputs.js